import { JsonConvert, OperationMode, ValueCheckingMode } from 'json2typescript';

class JSONSerializer {
  private jsonConvert: JsonConvert;

  constructor() {
    this.jsonConvert = new JsonConvert(
      OperationMode.ENABLE,
      ValueCheckingMode.DISALLOW_NULL,
      false,
    );
  }

  public serialize = (obj: object): any => {
    let jsonObj;
    try {
      jsonObj = this.jsonConvert.serialize(obj);
      return jsonObj;
    } catch (e) {
      // this.log.error({ obj, jsonObj, error: e.message }, 'Error while serializing object to JSON string.');
      throw e;
    }
  };

  public stringify = (obj: object): string => {
    const jsonObj = this.serialize(obj);
    return JSON.stringify(jsonObj);
  };

  public deserialize = <T>(input: object | string, classReference: new () => T): T => {
    let jsonObj;
    try {
      jsonObj = typeof input === 'string' ? JSON.parse(input) : input;
      const obj = this.jsonConvert.deserializeObject(jsonObj, classReference);

      // TODO: Do validations
      return obj;
    } catch (e) {
      // this.log.error({ input, jsonObj, error: e.message }, 'Error while deserializing JSON string/object.');
      throw e;
    }
  };

  public deserializeArray = <T>(input: any[] | string, classReference: new () => T): T[] => {
    let jsonArray: any[];
    try {
      jsonArray = typeof input === 'string' ? JSON.parse(input) : input;
      if (!Array.isArray(jsonArray)) {
        throw new Error('input is not a JSON array.');
      }
      const obj = this.jsonConvert.deserializeArray(jsonArray, classReference);
      // TODO: Do validations
      return obj;
    } catch (e) {
      // this.log.error({ input, jsonObj: jsonArray, error: e.message }, 'Error while deserializing JSON string/object.');
      throw e;
    }
  };
}

export default JSONSerializer;
